import { get } from 'lodash';
import { ColumnType } from '@inqool/uas-web-core/es/components/controls/Grid/constants';
import { typeEnum } from '@modules/employees/_employeesEnums';

// prettier-ignore
export const employeesRoleGridColumns = [
  { label: 'Osobní číslo', field: 'personalNumber', type: ColumnType.TEXT, width: 80 },
  { label: 'Služební číslo', field: 'officerNumber', type: ColumnType.TEXT, width: 80 },
  { label: 'Jméno', field: 'firstName', type: ColumnType.TEXT, width: 100 },
  { label: 'Přijmení', field: 'lastName', type: ColumnType.TEXT, width: 100 },
  {
    label: 'Role',
    sortable: false,
    filterComponent: () => null,
    type: ColumnType.JSX,
    jsx: ({ row, gridProps }) => {
      const { allRoles = {} } = gridProps;
      const { id } = row;
      const myRole = get(allRoles, `${id}.0.name`, '');
      return myRole;
    },
    width: 100
  },
  { label: 'Datum narození', field: 'birthDate', type: ColumnType.DATE, width: 200 },
  { label: 'Funkce', field: 'type', type: ColumnType.ENUM, enum: typeEnum, width: 80 }
];



// WEBPACK FOOTER //
// ./src/modules/roles-assing/_rolesAssignColumns.ts